import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./routes/homePage";
import Projects from "./routes/projects";
import Machinery from "./routes/machinery";
import Groups from "./routes/3hAndGroup";
import AboutUs from "./routes/aboutUs";
import ContactUs from "./routes/contactUs";
import Certificates from "./routes/certificates";
import Gallery from "./routes/gallery";
import Subsidiary from "./routes/subsidiary";
import Bank from "./routes/bank";
import EventsAndSeminar from "./routes/events";
import RoadsAndAsphalts from "./routes/roadsAndAsphalts";
function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/machineryequipments" element={<Machinery />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/importAndExports" element={<Subsidiary />} />
        <Route path="/3handGroup" element={<Groups />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/banksAndInsurances" element={<Bank />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/eventsAndSeminars" element={<EventsAndSeminar />} />
        <Route path="/roadsAndAsphalts" element={<RoadsAndAsphalts />} />
      </Routes>
    </>
  );
}

export default App;
